import { useCallback, useEffect } from 'react'

import { BridgeService } from '@/services'
import { Text } from '@interco/inter-ui/components/Text'
import useGlobalState from '@/contexts/global-state'
import { BaseContainer } from '@/components/base-container'
import { Signal } from '@interco/inter-ui/components/Signal'
import Canceled from '@interco/icons/orangeds/MD/canceled'
import { Button } from '@interco/inter-ui/components/Button'
import { eventTag5 } from '@/utils/tagEvent'

import * as S from './styles'

export const Feedback = () => {
  const [{ intl }] = useGlobalState()

  useEffect(() => {
    eventTag5()
  }, [])
  const goBack = useCallback(() => {
    BridgeService.interWbNavigate.requestGoBack()
  }, [])
  return (
    <BaseContainer onClickArrowLeft={goBack} headerTitle="" animationType="fade">
      <S.Container>
        <S.TopContainer>
          <S.Actions>
            <S.SigmalContainer>
              <Signal icon={Canceled} theme="error" intensity="dark" />
            </S.SigmalContainer>
          </S.Actions>
          <Text variant="headline-h1" colorWeight={500} semiBold>
            {intl.errorTitle}
          </Text>
          <Text variant="body-2">{intl.errorDescription}</Text>
        </S.TopContainer>
        <S.Actions>
          <Button fullWidth onClick={goBack}>
            {intl.errorButtonText}
          </Button>
        </S.Actions>
      </S.Container>
    </BaseContainer>
  )
}
